exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#menu-more, #menu-search {\n  left: 0;\n  position: absolute; }\n\n#menu-more {\n  opacity: 0;\n  pointer-events: none; }\n\n#wrapper {\n  height: 100%;\n  position: absolute;\n  width: 100%; }\n\n#wrapper > button {\n  font-family: Roboto;\n  height: 60px;\n  position: absolute;\n  width: 60px; }\n\n#wrapper > button > div {\n  font-family: Roboto;\n  font-size: 10px;\n  font-weight: 300;\n  height: 12px;\n  margin: 0 auto;\n  text-align: center;\n  transition: color 0.25s ease;\n  width: 100%;\n  position: absolute;\n  bottom: 7px; }\n\n#wrapper > button > img, #wrapper > button > div.menu-item-wrapper {\n  height: 26px;\n  transition: fill 0.25s ease;\n  max-width: 26px;\n  position: absolute;\n  top: 13px;\n  left: 0;\n  right: 0;\n  margin: 0 auto; }\n\n/* Desktop */\n:host.desktop > #wrapper > button {\n  width: 100%; }\n\n/*:host.desktop > #wrapper > button > img, :host.desktop > #wrapper > button > svg {\n  left: 22px;\n}*/\n#menu-button-4.desktop #menu-more {\n  opacity: 1; }\n\n#menu-button-4.desktop #menu-search {\n  opacity: 0;\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/menu/menu.component.scss
// module id = 409
// module chunks = 1